export default __webpack_public_path__ + "static/bee-good-badge-02b9325658693e213dec2ea1b508374a.svg";